import { AllowedHttpMethods, ticketReportApiConfig } from '../../apiList'
import {
  useAxios,
  getAuthenticatedRequestConfig,
} from '../../../../utils/apiUtils'
import {
  DepartmentNameList,
  GetTicketDetails,
  GetTicketsReport,
  TicketDetailsProps,
  TicketReportApiProps,
} from '../../../../types/Support/Report/ticketReportTypes'

const getDepartmentNameList = async (): Promise<DepartmentNameList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: ticketReportApiConfig.getDepartmentNameList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const commonLeaveReportParamsUtil = (props: TicketReportApiProps) => {
  return {
    dateSelection: props.dateSelection ?? '',
    departmentId: props.departmentId ?? '',
    from: props.from ?? '',
    ticketStatus: props.ticketStatus ?? '',
    to: props.to ?? '',
  }
}

const getTicketsReport = async (
  props: TicketReportApiProps,
): Promise<GetTicketsReport> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: ticketReportApiConfig.getTicketsReport,
    method: AllowedHttpMethods.get,
    params: commonLeaveReportParamsUtil(props),
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getTicketDetails = async (
  props: TicketDetailsProps,
): Promise<GetTicketDetails> => {
  const paramsLeaveReportResult = commonLeaveReportParamsUtil(props)
  const requestConfig = getAuthenticatedRequestConfig({
    url: ticketReportApiConfig.getTicketsDetails,
    method: AllowedHttpMethods.get,
    params: {
      ...paramsLeaveReportResult,
      startIndex: props.startIndex ?? 0,
      endIndex: props.endIndex ?? 20,
      filter: props.filter ?? '',
      subCategoryId: props.subCategoryId ?? '',
      categoryId: props.categoryId ?? '',
      trackerId: props.trackerId ?? '',
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const exportTicketReportData = async (
  props: TicketReportApiProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: ticketReportApiConfig.exportTicketReports,
    method: AllowedHttpMethods.get,
    params: {
      dateSelection: props.dateSelection ?? '',
      departmentId: props.departmentId ?? '',
      from: props.from ?? '',
      to: props.to ?? '',
      startIndex: props.startIndex ?? 0,
      endIndex: props.endIndex ?? 20,
      token: localStorage.getItem('token') ?? '',
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const ticketReportApi = {
  getDepartmentNameList,
  getTicketsReport,
  getTicketDetails,
  exportTicketReportData,
}

export default ticketReportApi
